// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c929b9fd","389":"ad243117","732":"d4fa8356","857":"7d45043c","977":"6f057b10"}[chunkId] + ".chunk.js";
};